import { Auth0ContextInterface, withAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { TranslationKeys } from 'translations';
import useCounter from 'v2/hooks/useCounter';
import { fetchUserObject, logoutUserAction } from '../../actions';
import { useTranslation } from 'react-i18next';

interface InactiveProps {
  auth0: Auth0ContextInterface;
  logoutUserAction: () => Promise<unknown>;
  fetchUserObject: () => Promise<unknown>;
}

const Inactive = ({
  auth0,
  logoutUserAction,
  fetchUserObject,
}: InactiveProps) => {
  const { t } = useTranslation();
  const logout = () => {
    logoutUserAction();
    auth0.logout({ returnTo: process.env.REACT_APP_LOGOUT_REDIRECT });
  };
  const counter = useCounter({ callback: logout, from: 15, to: 0 });

  useEffect(() => {
    fetchUserObject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="content_container p-0">
      <div className="jumbotron text-center user-submitted">
        <h1 className="display-3">Inactive.</h1>
        <p className="lead">
          Your account has been deactivated. Please contact an administrator at
          your {t(TranslationKeys.company_one)} to reactivate.
        </p>
        <hr />
        <p>You will be redirected to login page in {counter} seconds.</p>
      </div>
    </div>
  );
};

export default connect<InactiveProps>(null, {
  fetchUserObject,
  logoutUserAction,
})(withAuth0(Inactive));
